<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="fixed z-50 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div class="inline-block align-middle bg-white rounded-xl text-left overflow-hidden shadow-2xl transform transition-all w-full sm:w-11/12 md:w-2/3 lg:w-1/2 my-8">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">

          <div class="flex flex-col bg-white rounded p-2 sm:p-6">
            <div class="flex items-center justify-between mb-8 pb-4 border-b border-gray-100">
              <h3 class="text-lg leading-6 font-semibold text-gray-900" id="modal-title"> Move Retailer to Decommission List </h3>
              <button type="button" class="text-gray-400 hover:text-gray-600 transition-colors" @click="cancelDecommissionTransaction" aria-label="Close">
                <i class="fas fa-times text-lg"></i>
              </button>
            </div>



            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Retailer Phone</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <input  type="text" class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express" v-model.trim="form.phone" disabled/>
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Retailer Name</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <input  type="text" class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express" v-model.trim="form.name" placeholder="Full Name" disabled/>
              </div>
            </div>


            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Extra-Details</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <textarea v-model.trim="form.reason"  class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express" cols="30" rows="10"></textarea>
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Decommissioned Status</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <select v-model.trim="form.status" class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express">
                  <option value="pending">Pending ( Move Retailer to Decommission List, Handled by RDE) </option>
                  <option value="completed">Completed (All Devices Retrieved and Process Completed) </option>
                </select>
              </div>
            </div>



            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Assigned to RDE</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <select v-model="form.rde_personnel" class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express">
                  <option v-for="(item,index) in active_rde_list" v-bind:value="item.name" :key="index">
                    {{ item.name }} ( {{ item.email}})
                  </option>
                </select>
              </div>
            </div>


            <div class="flex flex-col sm:flex-row items-center justify-end gap-3 mt-8 pt-4 border-t border-gray-100">
              <button type="button" class="w-full sm:w-auto inline-flex justify-center rounded-lg px-5 py-2.5 bg-express text-sm font-medium text-white hover:bg-expressbutton transition-colors" @click="completeDecommissionTransaction">Move Retailer to Decommission List</button>
              <button type="button" class="w-full sm:w-auto inline-flex justify-center rounded-lg border border-gray-200 px-5 py-2.5 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" @click="cancelDecommissionTransaction">Close</button>
            </div>




          </div>




        </div>

      </div>
    </div>
  </div>
</template>

<script>



import {mapGetters} from "vuex";

export default {
  name: "add_retailer_to_decommission",
  props: ['retailer_id','name','phone'],
  emits:["completeDecommissionTransaction","cancelDecommissionTransaction"],
  created() {

    //get the list of retailers


    this.$store.dispatch('admins/action_rde_list',{
      page: 1,
      perPage: 1000,
      country: this.country,
      toast:this.$toast,
      router:this.$router
    });

    let temp = this.rde_list.data.filter(item => item.status === "Active" && item.type === "RDE")


    this.active_rde_list =  temp



    this.form.retailer_id = this.retailer_id
    this.form.name = this.name
    this.form.phone = this.phone
  },
  data(){
    return{
      active_rde_list:[],
      form:{
        name:null,
        phone:null,
        retailer_id:null,
        reason: null,
        rde_personnel:null,
        status: "pending",
      },
    }
  },
  computed: {
    ...mapGetters({
      rde_list: 'admins/rde_list',
      getUser: 'authentication/getUser'

    }),
  },
  watch:{

  },




  methods: {
    resetForm: function(){
      for (var item in this.form)
      {
        this.form[item] = null
      }
},
    completeDecommissionTransaction()  {
      console.log("this.form",this.form)
      // this.form.city = this.form.zone
      if( (this.form.rde_personnel  !== null )  ){
        this.$emit('completeDecommissionTransaction', this.form)
      }
      else{
          let fields = ''
           fields = fields+' Select  an RDE'
          this.$toast.error(`Error Missing fields:  ${fields}`)
      }
    },
    cancelDecommissionTransaction: function (e) {
      this.$emit('cancelDecommissionTransaction')
      this.resetForm()
    }
  }


}
</script>

<style scoped>

</style>
